export const compare = (firstValue, secondValue) => {
    if (firstValue > secondValue)
        return +1;
    if (firstValue < secondValue)
        return -1;
    return 0;
};
